import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";
import { StrategyEx } from "@front/m19-models";
import { TranslocoDirective } from "@jsverse/transloco";
import { StrategyInfoBlocComponent } from "@m19-board/shared/strategy-info-bloc/strategy-info-bloc.component";
import { IIconComponent, ITooltipDirective } from "@front/m19-ui";
import { DspCreativeTypeDescriptions } from "@m19-board/dsp/dsp-creatives/dsp-creative-type-selector/dsp-creative-type-selector.component";

@Component({
  selector: "app-strategy-page-dsp-creative-type",
  imports: [StrategyInfoBlocComponent, TranslocoDirective, IIconComponent, ITooltipDirective],
  template: `@if (dspStrategy(); as dspStrategy) {
    <app-strategy-info-bloc [disabled]="true" *transloco="let t">
      <div title class="text-sm text-gray-500 uppercase">
        {{ t("strategy-page.creative_type") }}
      </div>
      <div body class="inline-flex items-center gap-2">
        <IIcon [name]="DspCreativeTypeDescriptions[dspStrategy.creativeType!].icon" class="text-xl text-gray-500" />
        <span class="font-medium">{{ t(DspCreativeTypeDescriptions[dspStrategy.creativeType!].title) }}</span>
        <IIcon
          name="infoCircle"
          class="text-gray-500"
          [iTooltip]="t('strategy-page.creative_type_cannot_be_changed')"
        />
      </div>
    </app-strategy-info-bloc>
  }`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StrategyPageDspCreativeTypeComponent {
  protected readonly DspCreativeTypeDescriptions = DspCreativeTypeDescriptions;

  readonly strategy = input.required<StrategyEx>();

  readonly dspStrategy = computed(() => {
    const strategy = this.strategy();
    return strategy.isDspStrategy() ? strategy : null;
  });
}
